export default __webpack_public_path__ + "static/media/no0img.a4a50738.jpg";